import { createContext, useContext } from 'react';

// Permite que el contenido hardcodeado de journeyContent.tsx (ej. "ingresá a la pestaña
// Liquidación") dispare la navegación a otra sub-tab de Métricas, sin threadear un callback a
// través de cada JourneyResource.body. El callback real (cambiar `activeTab`) vive en
// ProfileMetricsTab, que es quien controla las sub-tabs — MetricsCaminoInicialTab solo lo pasa
// para abajo via este context.
export const JourneyNavigationContext = createContext<() => void>(() => undefined);

export function useGoToLiquidacion() {
  return useContext(JourneyNavigationContext);
}
